// tslint:disable:max-classes-per-file
var Site = /** @class */ (function () {
    function Site() {
    }
    return Site;
}());
export { Site };
var Market = /** @class */ (function () {
    function Market() {
    }
    return Market;
}());
export { Market };
